import { call, select } from "redux-saga/effects";
import { callAPI } from "./apiSaga";

const REACT_APP_FETCH_CONFIG =
  window.process !== undefined ? window.process.env.REACT_APP_FETCH_CONFIG : process.env.REACT_APP_FETCH_CONFIG;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
function getWebviewHostApp(state) {
  return state.params ? state.params.webviewHostApp : null;
}
function postMessageToModaris(Params, comando, webviewHostApp) {
  if (comando === "cancel") {
    window.chrome.webview.postMessage(Params);
  }
  if (comando === "sendUrl") {
    window.chrome.webview.postMessage(Params);
  }

  /*
  if (webviewHostApp == "Modaris" && window.chrome && window.chrome.webview && window.chrome.webview.postMessage)
    window.chrome.webview.postMessage(url);
  else window.open(url, "_blank");
  */
}
export function* CancelPatternConverter() {
  //alert("cancel de saga");
  const webviewHostApp = yield select(getWebviewHostApp);
  yield call(postMessageToModaris, "cancel:cancel", "cancel", webviewHostApp);
}
export function* DonePatternConverter(listFileName) {
  //alert("Done de saga");
  let DownloadJSON;
  let ArrayDownloadJSON = [];
  let nNumDownload = 0;
  let arrFileName = listFileName.payload.split(",");
  let arrFileNamelength = 0;
  if (arrFileName[0] !== "") arrFileNamelength = arrFileName.length;
  else arrFileNamelength = 0;
  for (let i = 0; i < arrFileNamelength; i++) {
    let fileFromArray = arrFileName[i];
    const url = REACT_APP_FETCH_CONFIG + "-mdl/urimdl/" + fileFromArray;

    const { success, result } = yield call(callAPI, { url });

    if (success) {
      DownloadJSON = isJson(result) ? JSON.parse(result) : {};
      if (DownloadJSON.documentId !== "") DownloadJSON.uri = "";
      ArrayDownloadJSON.push(DownloadJSON);

      nNumDownload++;
    }
  }
  //AllDownloadJSON = isJson(AllDownload) ? JSON.parse(AllDownload) : {};
  const webviewHostApp = yield select(getWebviewHostApp);

  let ObjResponmseToModaris = JSON.parse('{"Files":"[]"}');
  if (nNumDownload > 0) ObjResponmseToModaris.Files = ArrayDownloadJSON;
  let ParamToSend = JSON.stringify(ObjResponmseToModaris);
  yield call(postMessageToModaris, ParamToSend, "sendUrl", webviewHostApp);
}
